import * as React from 'react';

import { SkillCategoryInterface } from './interfaces';

import {
  EXTRA_SMALL_ICON_BASE_SRC,
  SMALL_ICON_BASE_SRC,
} from '../../../../Shared/index';

const fileDocumentImgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/file-document.svg`;
const pencilImgSrc = `${SMALL_ICON_BASE_SRC}/pencil.svg`
const arrowDownImgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/arrow-down.svg`

interface SkillsReportHeaderProps {
  byStudent: boolean;
  selectedSkillCategory?: SkillCategoryInterface | undefined;
  setShowMomentumScoreGoalModal: (show: boolean) => void;
  title: string;
}

const forwardSlash = <span className="forward-slash"> / </span>

const SkillsReportHeader: React.FC<SkillsReportHeaderProps> = ({
  byStudent,
  selectedSkillCategory,
  setShowMomentumScoreGoalModal,
  title
}) => {
  function handleClickChangeGoal() {
    setShowMomentumScoreGoalModal(true)
  }
  function handleClickDownload() {
    window.print()
  }
  return (
    <header>
      <h1>
        <b>Skills Report</b>
        {forwardSlash}
        {title}
        {forwardSlash}
        {byStudent ? 'By Student' : 'By Skill'}
        {selectedSkillCategory ? <React.Fragment>{forwardSlash}{selectedSkillCategory.name}</React.Fragment> : null}
      </h1>
      <div className="links">
        <a className="quill-button outlined small grey focus-on-light" href='https://support.quill.org/en/articles/12062553-how-do-i-read-the-skills-report-quill-premium' rel="noopener noreferrer" target="_blank">
          <img alt="" src={fileDocumentImgSrc} />
          Guide
        </a>
        <button className="quill-button outlined small grey focus-on-light" onClick={handleClickChangeGoal} type="button">
          <img alt="" src={pencilImgSrc} />
          Change goal
        </button>
        <button className="quill-button outlined small grey focus-on-light" onClick={handleClickDownload} type="button">
          <img alt="" src={arrowDownImgSrc} />
          Download
        </button>
      </div>
    </header>
  );
};

export default SkillsReportHeader;
